"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.throwInternalError = exports.throwRuntimeError = exports.throwInvalidTagName = exports.throwUnexpectedToken = exports.throwUnexpectedEndOfInput = exports.throwNotDefinedError = void 0;
function throwNotDefinedError(context, funcName) {
    let error = new ReferenceError(`${funcName} is not defined (jz001)`);
    error.context = context;
    throw error;
}
exports.throwNotDefinedError = throwNotDefinedError;
function throwUnexpectedEndOfInput(context, expected) {
    let error = new SyntaxError(`Expected ${expected.join(' or ')}, but read end of input (jz101)`);
    error.context = context;
    throw error;
}
exports.throwUnexpectedEndOfInput = throwUnexpectedEndOfInput;
function throwUnexpectedToken(context, token) {
    let error = new SyntaxError(`Unexpected token: ${token} (jz102)`);
    error.context = context;
    throw error;
}
exports.throwUnexpectedToken = throwUnexpectedToken;
function throwInvalidTagName(context, char) {
    let error = new Error(`Invalid character in tag name: '${char}'. Only hyphen, underline, latin letter and '$' are valid (jz103)`);
    error.context = context;
    throw error;
}
exports.throwInvalidTagName = throwInvalidTagName;
function throwRuntimeError(context, e) {
    let error = new Error(`Runtime error: ${e} (jz201)`);
    error.context = context;
    throw error;
}
exports.throwRuntimeError = throwRuntimeError;
function throwInternalError(context, e) {
    let error = new Error(`Internal error: ${e} (jz202)`);
    error.context = context;
    throw error;
}
exports.throwInternalError = throwInternalError;
